import Vue from 'vue';
import axios from 'axios';
import store from '@/store/store'

Vue.use({
    install (Vue) {
        Vue.prototype.$http = axios;
    }
})

axios.interceptors.response.use(
    res => res,
    err => {
        if(!err.response) {
            store.dispatch('limparMensagens', [])
            store.dispatch('throwError', ['Não foi possível conectar-se ao servidor. Contate o seu administrador do sistema.'])
            return Promise.reject(err);
        }
        if(err.response.status === 500) {
            store.dispatch('throwError', [err.response.data.message])
            return Promise.reject(err.response.data.message);
        }
        if(err.response.status === 404) {
            store.dispatch('throwError', ['Não foi encontrada a chamada da URL no servidor. Contate o seu administrador do sistema.'])
            return Promise.reject(err.response.data.message);
        }
    }
)